const counties = (counties = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_COUNTIES':
      return action.payload
    default:
      return counties
  }
}
export default counties
